'use client';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';


const floatingCards = [
{
  id: 'card-followers',
  icon: '👥',
  label: 'Abonnés ajoutés',
  value: '+1 500',
  sub: 'Kofi M. · il y a 2 min',
  color: '#1877F2',
  style: { top: '12%', right: '4%' },
  floatClass: 'float-a'
},
{
  id: 'card-likes',
  icon: '👍',
  label: 'Likes reçus',
  value: '+3 200',
  sub: 'Aminata K. · il y a 5 min',
  color: '#F4A923',
  style: { bottom: '28%', right: '2%' },
  floatClass: 'float-b'
},
{
  id: 'card-comments',
  icon: '💬',
  label: 'Commentaires',
  value: '+850',
  sub: 'Yao B. · il y a 8 min',
  color: '#10B981',
  style: { bottom: '12%', left: '2%' },
  floatClass: 'float-c'
}];


const liveNotifs = [
{ name: 'Aya Coulibaly', action: 'a commandé 500 abonnés', time: '2 min', flag: '🇨🇮' },
{ name: 'Moussa Traoré', action: 'a acheté 1 000 likes', time: '5 min', flag: '🇨🇮' },
{ name: 'Fatou Diallo', action: 'a commandé 200 commentaires', time: '9 min', flag: '🇨🇮' },
{ name: 'Jean-Baptiste K.', action: 'a acheté 2 000 abonnés', time: '12 min', flag: '🇨🇮' }];


export default function HeroSection() {
  const [notifIndex, setNotifIndex] = useState(0);
  const [showNotif, setShowNotif] = useState(false);
  const [mounted, setMounted] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    setMounted(true);
    setShowNotif(true);
    intervalRef.current = setInterval(() => {
      setShowNotif(false);
      setTimeout(() => {
        setNotifIndex((i) => (i + 1) % liveNotifs?.length);
        setShowNotif(true);
      }, 600);
    }, 5000);
    return () => {if (intervalRef?.current) clearInterval(intervalRef?.current);};
  }, []);

  const notif = liveNotifs?.[notifIndex];

  return (
    <section className="hero-bg min-h-screen flex flex-col justify-center relative overflow-hidden pt-20">
      {/* Decorative circles */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full border border-white/5 pointer-events-none" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full border border-white/5 pointer-events-none" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[200px] h-[200px] rounded-full border border-white/8 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24 w-full relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-6 items-center">
          {/* Left: Text content */}
          <div className="flex flex-col gap-6">
            {/* Label */}
            <div
              className="animate-fade-up opacity-0 inline-flex items-center gap-2 self-start px-4 py-2 rounded-full"
              style={{ background: 'rgba(244,169,35,0.15)', border: '1px solid rgba(244,169,35,0.3)', animationFillMode: 'forwards' }}>

              <span className="w-2 h-2 rounded-full bg-[#F4A923] animate-pulse" />
              <span className="text-[#F4A923] text-xs font-bold tracking-widest uppercase">
                🇨🇮 #1 en Côte d'Ivoire
              </span>
            </div>

            {/* Headline */}
            <h1
              className="animate-fade-up opacity-0 delay-100 text-white font-heading leading-[1.05]"
              style={{ fontSize: 'clamp(2.4rem,6vw,4.2rem)', fontWeight: 900, animationFillMode: 'forwards' }}>

              Boostez vos{' '}
              <span className="gradient-text-gold">réseaux</span>
              <br />
              en quelques{' '}
              <span
                style={{
                  fontStyle: 'italic',
                  fontWeight: 300,
                  color: 'rgba(255,255,255,0.55)'
                }}>

                minutes.
              </span>
            </h1>

            {/* Sub */}
            <p
              className="animate-fade-up opacity-0 delay-200 text-white/65 leading-relaxed max-w-lg"
              style={{ fontSize: 'clamp(1rem,2vw,1.15rem)', fontWeight: 400, animationFillMode: 'forwards' }}>Achetez des abonnés, likes et commentaires réels livrés rapidement. Paiement via Orange Money, MTN MoMo et Wave.


            </p>

            {/* Trust badges */}
            <div className="animate-fade-up opacity-0 delay-300 flex flex-wrap gap-3" style={{ animationFillMode: 'forwards' }}>
              {[
              { icon: '⚡', text: 'Livraison Express' },
              { icon: '🔒', text: 'Paiement Sécurisé' },
              { icon: '✅', text: 'Comptes Réels' }]?.
              map((b) =>
              <span
                key={b?.text}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold text-white/80"
                style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }}>

                  {b?.icon} {b?.text}
                </span>
              )}
            </div>

            {/* CTAs */}
            <div className="animate-fade-up opacity-0 delay-400 flex flex-col sm:flex-row gap-3" style={{ animationFillMode: 'forwards' }}>
              <Link
                href="/services"
                className="btn-gold text-center py-4 px-8 text-base"
                style={{ borderRadius: 50, textDecoration: 'none', display: 'inline-block', fontFamily: 'Plus Jakarta Sans,sans-serif', fontWeight: 800, color: '#0D1B3E', background: 'linear-gradient(135deg,#F4A923 0%,#E8920F 100%)', boxShadow: '0 4px 20px rgba(244,169,35,0.35)', transition: 'all 0.3s' }}>

                🚀 Commander maintenant
              </Link>
              <Link
                href="/services"
                className="btn-outline text-center py-4 px-8 text-base"
                style={{ borderRadius: 50, textDecoration: 'none', display: 'inline-block', fontFamily: 'Plus Jakarta Sans,sans-serif', fontWeight: 600, color: 'white', border: '1.5px solid rgba(255,255,255,0.35)', transition: 'all 0.3s' }}>

                Voir les tarifs →
              </Link>
            </div>

            {/* Stats row */}
            <div className="animate-fade-up opacity-0 delay-500 flex gap-8 pt-2" style={{ animationFillMode: 'forwards' }}>
              {[
              { n: '12 500+', l: 'Commandes livrées' },
              { n: '4.9/5', l: 'Note moyenne' },
              { n: '< 1h', l: 'Délai livraison' }]?.
              map((s) =>
              <div key={s?.l}>
                  <div className="text-white font-heading font-bold text-xl">{s?.n}</div>
                  <div className="text-white/45 text-xs mt-0.5">{s?.l}</div>
                </div>
              )}
            </div>
          </div>

          {/* Right: Visual */}
          <div className="relative h-[420px] sm:h-[500px] hidden lg:block">
            {/* Central phone mockup */}
            <div
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 rounded-[2.5rem] overflow-hidden shadow-[0_32px_80px_rgba(0,0,0,0.5)]"
              style={{ border: '3px solid rgba(255,255,255,0.15)' }}>

              <div style={{ background: 'linear-gradient(160deg,#1877F2 0%,#0D1B3E 100%)', padding: '16px 12px 24px' }}>
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-white font-bold text-sm">A</div>
                  <div>
                    <div className="text-white text-xs font-bold">Aya Coulibaly</div>
                    <div className="text-white/50 text-[10px]">Page Facebook</div>
                  </div>
                </div>
                {/* Fake post */}
                <div className="bg-white/10 rounded-xl p-3 mb-3">
                  <div className="h-2 bg-white/20 rounded mb-1.5 w-3/4" />
                  <div className="h-2 bg-white/15 rounded w-1/2" />
                </div>
                {/* Engagement bar */}
                <div className="flex items-center justify-between mt-3 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                  <div className="flex items-center gap-1 text-white/70 text-xs">
                    <span>👍</span><span className="font-bold text-white">3.2k</span>
                  </div>
                  <div className="flex items-center gap-1 text-white/70 text-xs">
                    <span>💬</span><span className="font-bold text-white">842</span>
                  </div>
                  <div className="flex items-center gap-1 text-white/70 text-xs">
                    <span>↗️</span><span className="font-bold text-white">1.1k</span>
                  </div>
                </div>
                {/* Followers badge */}
                <div className="mt-3 flex items-center justify-center gap-1.5 py-2 rounded-xl" style={{ background: 'rgba(244,169,35,0.2)', border: '1px solid rgba(244,169,35,0.3)' }}>
                  <span className="text-[#F4A923] text-xs font-bold">👥 14 500 abonnés</span>
                </div>
              </div>
            </div>

            {/* Floating cards */}
            {floatingCards?.map((card) =>
            <div
              key={card?.id}
              className={`absolute glass rounded-2xl px-4 py-3 shadow-xl ${card?.floatClass}`}
              style={{ ...card?.style, minWidth: 160 }}>

                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">{card?.icon}</span>
                  <span className="text-xs font-semibold text-[#6B7280]">{card?.label}</span>
                </div>
                <div className="font-heading font-bold text-xl" style={{ color: card?.color }}>{card?.value}</div>
                <div className="text-[10px] text-[#9CA3AF] mt-0.5">{card?.sub}</div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Live notification toast */}
      {mounted && showNotif &&
      <div
        className="notif-toast notif-animate"
        style={{ animationFillMode: 'forwards' }}>

          <div className="glass rounded-2xl px-4 py-3 shadow-xl flex items-center gap-3" style={{ border: '1px solid rgba(255,255,255,0.7)' }}>
            <span className="text-xl">{notif?.flag}</span>
            <div>
              <span className="text-xs font-bold text-[#0D1B3E]">{notif?.name}</span>
              <span className="text-xs text-[#6B7280]"> {notif?.action}</span>
              <div className="text-[10px] text-[#9CA3AF] mt-0.5">Il y a {notif?.time}</div>
            </div>
            <div className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse ml-1 flex-shrink-0" />
          </div>
        </div>
      }
      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" style={{ height: 60 }}>
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
          <path d="M0 60 L0 30 Q360 0 720 30 Q1080 60 1440 30 L1440 60 Z" fill="#F4F6FB" />
        </svg>
      </div>
    </section>);

}